import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-assessment-complete',
  templateUrl: './assessment-complete.component.html',
  styleUrls: ['./assessment-complete.component.scss']
})
export class AssessmentCompleteComponent implements OnInit {

  constructor(public dataSvc: DataService) { }

  ngOnInit() {
  }

  endExam() {
    this.dataSvc.EndExam();
  }
}
